import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { maxHeight } from '@material-ui/system'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import { useGetWarehouseNameQuery } from 'generated/graphql'
import React from 'react'
import { useHistory, useLocation, useParams } from 'react-router'

export const StockTransferReport = () => {
  const history = useHistory()
  const { WarehouseID, BankAccountID }: any = useParams()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const editData = location?.state as any

  const {
    loading: WarehouseLoading,
    error: WarehouseError,
    data: { getWarehouse } = { getWarehouse: [] },
  } = useGetWarehouseNameQuery({
    variables: { WarehouseID },
    fetchPolicy: 'network-only',
  })

  const parameters = [
    {
      name: 'accountid',
      value: accountID,
    },
    {
      name: 'companyid',
      value: editData?.CompanyID,
    },
    {
      name: 'docstartdate',
      value: new Date(editData?.DocStartDate.setHours(0, 0, 0)).toISOString(),
    },
    {
      name: 'docenddate',
      value: new Date(editData?.DocEndDate.setHours(0, 0, 0)).toISOString(),
    },
    {
      name: 'trxnstartdate',
      value: !!editData?.TrxnStartDate
        ? new Date(editData?.TrxnStartDate.setHours(0, 0, 0)).toISOString()
        : null,
    },
    {
      name: 'trxnenddate',
      value: !!editData?.TrxnEndDate
        ? new Date(editData?.TrxnEndDate.setHours(0, 0, 0)).toISOString()
        : null,
    },
    {
      name: 'docno',
      value: editData?.DocNo,
    },
    {
      name: 'docref',
      value: editData?.DocRef,
    },
    {
      name: 'fwarehouse',
      value: editData?.FromWarehouseID,
    },
    {
      name: 'twarehouse',
      value: editData?.ToWarehouseID,
    },
    {
      name: 'category',
      value: editData?.CategoryID,
    },
    {
      name: 'stockitem',
      value: editData?.StockItemID,
    },
    {
      name: 'amount',
      value: editData?.Amount,
    },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      {WarehouseLoading && <Loading />}
      <MainHeader
        onClick={() => history.push(`/digital-reports/inventory-control`)}
        mainBtn="close"
        smTitle="Inventory Control"
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Digital Reporting' },
          { name: 'Stock Transfer Report', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('StockTransferReport', parameters),
          host: accountxReportUrl,
          // host: contractReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  )
}
